import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {EBOOKS, getEbookDownloadUrl} from "@pg-mono/ebooks";

import {ArticleEbookCard} from "./ArticleEbookCard";

interface IEbookSectionProps {
    className?: string;
}

export const ArticleEbookSection = (props: IEbookSectionProps) => {
    const {className} = props;

    return (
        <section className={cx(className, sectionStyle)}>
            <div className={articleContainer}>
                <Text variant="headline_4" as="div">
                    Pobierz darmowe e-booki
                </Text>
                <Text className={css({mb: 4})} variant="body_copy_0" as="div">
                    Poszerz swoją wiedzę o zakupie mieszkania
                </Text>

                <div className={ebookListing}>
                    {EBOOKS.map((ebook) => (
                        <ArticleEbookCard key={ebook.id} source={ebook.cover} title={ebook.title} downloadURL={getEbookDownloadUrl(ebook.pdfFileName, "rp")} />
                    ))}
                </div>
            </div>
        </section>
    );
};

const articleContainer = css({
    pl: 2,
    pr: 2,

    md: {
        maxWidth: `calc(103.2rem + 8rem);`, // moved from ArticleContainer - 103.2rem is container width and 8rem is for padding
        ml: "auto",
        mr: "auto",
        pl: "4rem",
        pr: "4rem"
    }
});

const ebookListing = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 3,

    md: {
        columnGap: 3,
        flexDirection: "row",
        justifyContent: "space-between"
    }
});

const sectionStyle = css({
    backgroundColor: "var(--colors-background-200)",
    pb: 5,
    pt: 3,

    md: {
        pb: 9,
        pt: 5
    }
});
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {EBOOKS, getEbookDownloadUrl} from "@pg-mono/ebooks";

import {ArticleEbookCard} from "./ArticleEbookCard";

interface IEbookSectionProps {
    className?: string;
}

export const ArticleEbookSection = (props: IEbookSectionProps) => {
    const {className} = props;

    return (
        <section className={cx(className, sectionStyle)}>
            <div className={articleContainer}>
                <Text variant="headline_4" as="div">
                    Pobierz darmowe e-booki
                </Text>
                <Text className={css({mb: 4})} variant="body_copy_0" as="div">
                    Poszerz swoją wiedzę o zakupie mieszkania
                </Text>

                <div className={ebookListing}>
                    {EBOOKS.map((ebook) => (
                        <ArticleEbookCard key={ebook.id} source={ebook.cover} title={ebook.title} downloadURL={getEbookDownloadUrl(ebook.pdfFileName, "rp")} />
                    ))}
                </div>
            </div>
        </section>
    );
};

const articleContainer = css({
    pl: 2,
    pr: 2,

    md: {
        maxWidth: `calc(103.2rem + 8rem);`, // moved from ArticleContainer - 103.2rem is container width and 8rem is for padding
        ml: "auto",
        mr: "auto",
        pl: "4rem",
        pr: "4rem"
    }
});

const ebookListing = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 3,

    md: {
        columnGap: 3,
        flexDirection: "row",
        justifyContent: "space-between"
    }
});

const sectionStyle = css({
    backgroundColor: "var(--colors-background-200)",
    pb: 5,
    pt: 3,

    md: {
        pb: 9,
        pt: 5
    }
});
